const leads = {
  name: 'Lead |||| Leads',
  fields: {
    firstName: 'Nombre',
    lastName: 'Apellidos',
    treatment: 'Tratamiento',
    email: 'Email',
    secondaryEmail: 'Email secundario',
    mobilePhone: 'Teléfono móvil',
    landlinePhone: 'Teléfono fijo',
    city: 'Ciudad',
    region: 'Región',
    country: 'País',
    status: 'Estado',
    preferredLanguage: 'Idioma preferido',
    acceptsNewsletter: 'Acepta newsletter',
    notes: 'Observaciones',
    hotelName: 'Hotel',
    lastContactDate: 'Último contacto',
    nextContactDate: 'Próximo contacto',
    isArchived: 'Archivado',
    createdAt: 'Fecha de creación',
    updatedAt: 'Última actualización',
    personalMobilePhone: 'Móvil personal',
    phoneExtension: 'Extensión',
    address: 'Dirección',
    linkedInUrl: 'LinkedIn',
    website: 'Web',
    consentDate: 'Fecha de consentimiento',
    consentOrigin: 'Origen del consentimiento',
    companyName: 'Empresa',
    jobTitleName: 'Cargo',
    contactTypeName: 'Tipo de contacto',
    leadSourceName: 'Procedencia',
    hotelChainName: 'Cadena propia',
    effectiveChainName: 'Cadena',
    hotelCategoryName: 'Tipología hotel',
    hotelPmsSystemName: 'PMS',
    hotelLockSystemName: 'Cerradura',
    hotelPaymentProcessorName: 'Proc. pago',
    tagNames: 'Tags',
    interestNames: 'Intereses',
  },
  filters: {
    archived: 'Archivados',
    includeArchived: 'Incluir archivados',
    searchNotes: 'Buscar también en observaciones',
    fieldFilters: 'Filtros por campo',
    company: 'Empresa (contiene)',
    hotel: 'Hotel (contiene)',
    emailDomainsInclude: 'Dominio email (incluir)',
    emailDomainsExclude: 'Dominio email (excluir)',
    domainsHelp: 'Separe varios dominios con comas',
    countries: 'Países',
    regions: 'Regiones / Provincias',
    jobTitles: 'Cargos',
    contactType: 'Tipo de contacto',
    leadSource: 'Procedencia',
    chains: 'Cadenas',
    individualHotels: 'Hoteles individuales (sin cadena)',
    chainMinHotels: 'Cadena con nº mínimo de hoteles',
    pmsSystems: 'PMS',
    lockSystems: 'Cerraduras',
    paymentProcessors: 'Procesadores de pago',
    hotelCategories: 'Tipologías de hotel',
    status: 'Estado',
    language: 'Idioma preferido',
    newsletter: 'Newsletter',
    newsletterYes: 'Sí',
    newsletterNo: 'No',
    tags: 'Tags',
    tagMode: 'Modo de tags',
    interests: 'Intereses',
    interestMode: 'Modo de intereses',
    modeAll: 'Todos (Y)',
    modeAny: 'Cualquiera (O)',
    lastContactFrom: 'Últ. contacto desde',
    lastContactTo: 'Últ. contacto hasta',
    nextContactFrom: 'Próx. contacto desde',
    nextContactTo: 'Próx. contacto hasta',
  },
  sections: {
    basicInfo: 'Datos básicos',
    contactInfo: 'Datos de contacto',
    location: 'Dirección',
    classification: 'Clasificación',
    crm: 'Seguimiento y consentimiento',
    tagsInterests: 'Tags e intereses',
  },
  tabs: {
    personal: 'Personal',
    contact: 'Contacto',
    address: 'Dirección',
    crm: 'CRM',
    tags: 'Tags',
    interests: 'Intereses',
    notes: 'Observaciones',
  },
  actions: {
    archive: 'Archivar',
    restore: 'Restaurar',
  },
  newsletter: {
    button: 'Enviar newsletter',
    title: 'Enviar newsletter',
    funnel: 'Con los filtros actuales: %{total} leads, %{withEmail} con email, %{optIn} aceptan newsletter.',
    loadingPreview: 'Calculando destinatarios…',
    onlyOptIn: 'Enviar solo a quienes aceptan newsletter (RGPD)',
    template: 'Plantilla',
    noTemplate: '(sin plantilla — componer abajo)',
    subject: 'Asunto',
    body: 'Cuerpo del mensaje',
    placeholdersHelp: 'Variables disponibles: {nombre} {apellidos} {tratamiento} {empresa} {hotel} {cargo} {ciudad} {pais} {email}',
    inlineRequired: 'Introduzca el asunto y el cuerpo del mensaje',
    confirm: 'Se enviará "%{what}" a %{count} destinatarios. ¿Desea continuar?',
    send: 'Enviar (%{count})',
    result: 'Enviados: %{sent} · Fallidos: %{failed} · Sin email: %{skipped}',
    error: 'No se pudo completar el envío',
  },
  bulk: {
    groupEdit: 'Editar grupo',
    purge: 'Borrar definitivamente',
    title: 'Editar grupo (%{count} leads)',
    fieldsSection: 'Campos directos (marque los que desea modificar; vacío = borrar el valor)',
    setsSection: 'Tags e intereses',
    hotelAttrsSection: 'Atributos del hotel',
    hotelAttrsWarning:
      'Atención: estos cambios se aplican a los hoteles de los leads seleccionados y afectan también al resto de leads de esos hoteles.',
    modeNone: 'No cambiar',
    modeAdd: 'Añadir',
    modeRemove: 'Quitar',
    modeReplace: 'Reemplazar',
    apply: 'Aplicar cambios',
    confirm: 'Se aplicarán los cambios (%{operations}) a %{count} leads. ¿Desea continuar?',
    archiveConfirm: '¿Desea archivar %{count} leads?',
    purgeConfirm:
      'ATENCIÓN: se eliminarán definitivamente %{count} leads. Esta acción no se puede deshacer. ¿Desea continuar?',
    done: 'Operación aplicada correctamente a %{count} leads',
    hotelAttrsDone: 'Atributos actualizados en %{hotels} hoteles (%{leads} leads afectados)',
    summaryFields: 'campos directos',
    summaryTags: 'tags',
    summaryInterests: 'intereses',
    summaryHotelAttrs: 'atributos de hotel',
    error: 'No se pudo completar la operación',
  },
  messages: {
    created: 'Lead creado correctamente',
    updated: 'Lead actualizado correctamente',
    archived: 'Lead archivado correctamente',
    restored: 'Lead restaurado correctamente',
    duplicateEmail:
      'Ya existe otro contacto (%{name}) con este email. ¿Desea guardar de todos modos?',
  },
  edit: {
    title: 'Editar lead',
  },
  create: {
    title: 'Crear lead',
  },
  help: {
    editBanner:
      'Edite los datos del lead a continuación. Los campos obligatorios están marcados con un asterisco.',
    createBanner:
      'Introduzca al menos un nombre o un email para crear el lead. El resto de datos se completan desde la ficha.',
  },
  empty: 'No se encontraron leads',
  invite: 'Cree su primer lead',
};

export default leads;
